import { FC } from 'react';

export const Modem: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M6.20497 10.5579C5.72603 8.7696 6.08734 6.80314 7.2889 5.28374M17.7955 10.5578C18.2744 8.76955 17.9131 6.80309 16.7115 5.28369M2.34207 11.5996C1.50412 8.47489 2.20568 5.02325 4.44675 2.44588M21.6549 11.5997C22.4929 8.47493 21.7913 5.0233 19.5502 2.44592M12.0002 15V9M5.50022 18.5H9.50022M5.20022 22H18.8002C19.9203 22 20.4804 22 20.9082 21.782C21.2845 21.5903 21.5905 21.2843 21.7822 20.908C22.0002 20.4802 22.0002 19.9201 22.0002 18.8V18.2C22.0002 17.0799 22.0002 16.5198 21.7822 16.092C21.5905 15.7157 21.2845 15.4097 20.9082 15.218C20.4804 15 19.9203 15 18.8002 15H5.20022C4.08012 15 3.52006 15 3.09224 15.218C2.71592 15.4097 2.40996 15.7157 2.21821 16.092C2.00022 16.5198 2.00022 17.0799 2.00022 18.2V18.8C2.00022 19.9201 2.00022 20.4802 2.21821 20.908C2.40996 21.2843 2.71592 21.5903 3.09224 21.782C3.52006 22 4.08012 22 5.20022 22Z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
